export const hasRank = (rankName?: string | null) => {
  const name = rankName
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

  return !!name && name !== "sin rango";
};
